import styled from "styled-components";

export const Container = styled.section``;

export const GridList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  @media screen and (max-width: 991px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ArticleBox = styled.article`
  cursor: pointer;
  width: 100%;
`;

export const InfoBox = styled.div`
  margin-top: 10px;
`;

export const Thumbnail = styled.div`
  width: 100%;
  overflow: hidden;
  & img {
    max-height: 400px;
    height: auto;
  }
`;

export const Title = styled.div`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: keep-all;
  @media screen and (max-width: 991px) {
    & h5 {
      font-size: 18px;
    }
  }
  @media screen and (max-width: 767px) {
    & h5 {
      font-size: 16px;
    }
  }
`;

export const SubTitle = styled.h6`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  @media screen and (max-width: 991px) {
    font-size: 14px;
  }
`;

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  .pagination {
    justify-content: center !important;
  }

  @media screen and (max-width: 575px) {
    display: none;
  }
`;

const MobilePaginationWrapper = styled.div`
  display: none;
  justify-content: center;
  width: 100%;

  .pagination {
    justify-content: center !important;
  }

  .disabled {
    .page-link {
      opacity: 0;
    }
  }

  @media screen and (max-width: 575px) {
    display: flex;
  }
`;
